var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackToHomePageDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M5.826.243L.237 5.94h-.01c-.01.01-.02.03-.04.05-.019.02-.039.05-.058.07l-.03.061c-.01.03-.03.05-.04.08-.01.031-.02.051-.02.082a.19.19 0 0 0-.02.07c-.01.05-.019.101-.019.151 0 .05.01.111.02.162 0 .02.01.04.02.07.01.03.01.06.03.081.01.03.029.05.039.07l.03.061c.02.03.039.05.059.07.01.02.02.03.04.051h.01l5.588 5.697a.783.783 0 0 0 1.118 0 .8.8 0 0 0 .227-.575.843.843 0 0 0-.227-.575L2.7 7.321h12.335a.801.801 0 0 0 .791-.807.801.801 0 0 0-.791-.806H2.7l4.244-4.325A.8.8 0 0 0 7.17.808a.843.843 0 0 0-.227-.575.775.775 0 0 0-1.118.01z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToHomePageDesktop);
export default __webpack_public_path__ + "static/media/back-to-home-page-desktop.e7bc9b8d05197941a4886cb5ea79b479.svg";
export { ForwardRef as ReactComponent };